// extracted by mini-css-extract-plugin
export var cardContainer = "_nl-0";
export var cardHeader = "_nl-2";
export var collapsedState = "_nl-3";
export var dragHandle = "_nl-5";
export var dragHandleIcon = "_nl-6";
export var dragging = "_nl-1";
export var titleArea = "_nl-4";